module.exports = __webpack_public_path__ + "static/media/menu-arrow.1386fa01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/Menu/assets/menu-arrow.svg
// module id = ./src/common/Menu/assets/menu-arrow.svg
// module chunks = 14